<template lang="pug">
  header.header
    a.header__logo(:class="{ partner }" href="https://www.ciclic.com.br/seguro-viagem/")
    b.header__label Viagem
</template>

<script>
export default {
  name: 'Header',
  props: {
    partner: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

.header {
  align-items: center;
  display: flex;
  background-color: $white;
  border-bottom: solid 1px #dfdfdf;
  height: 56px;
  padding: 0 16px;
  position: sticky;
  top: 0px;
  z-index: 11;

  @media screen and (min-width: 768px) {
    border-bottom: none;
    box-shadow: 0 2px 4px 0 #e2e8f7;
    height: 76px;
  }

  .partner {
    width: 100px;
    height: 100px;
    background-image: url('~@/assets/partner/a2g.jpg') !important;
    background-size: 100%;
  }

  &__logo {
    background-image: url('https://static.ciclic.com.br/svg/ciclic-logo.svg');
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    height: 23px;
    width: 100px;
    transition: background-image 400ms;
  }

  &__label {
    display: none;

    @media screen and (min-width: 768px) {
      border-left: 1px solid $base-color;
      color: $base-color;
      display: block;
      font-family: $oscine-font-family;
      font-size: 16px;
      height: 24px;
      margin-left: 15px;
      padding-left: 8px;
      position: relative;
    }
  }

  .success & {
    border-bottom: none;
    box-shadow: 0 2px 4px 0 #e2e8f7;
  }
}
</style>
